$(document).ready(function(){

  // -- banners --
  var sliderBanner = $('.slider__banner');
  sliderBanner.flickity({
    autoPlay: 6000,
    pauseAutoPlayOnHover: false,
    cellAlign: 'center',
    contain: false,
    wrapAround: true,
    freeScroll: false,
    imagesLoaded: true,
    cellSelector: '.slider__banner .image',
    accessibility: true,
    percentPosition: false,
    setGallerySize: false,
    pageDots: false,
    prevNextButtons: false,
  });

  // -- exhibitions --
  var sliderExhibitions = $('.slider__exhibitions');
  sliderExhibitions.flickity({
    cellAlign: 'left',
    contain: true,
    freeScroll: false,
    imagesLoaded: true,
    cellSelector: '.slider__exhibitions .exhibition',
    accessibility: true,
    percentPosition: false,
    setGallerySize: false,
    pageDots: false,
    prevNextButtons: false,
  });

  // -- gallery --
  var sliderGallery = $('.slider__gallery');
  sliderGallery.flickity({
    cellAlign: 'center',
    contain: false,
    freeScroll: false,
    imagesLoaded: true,
    cellSelector: '.slider__gallery .image',
    accessibility: true,
    percentPosition: false,
    setGallerySize: false,
    pageDots: false,
    prevNextButtons: true,
    arrowShape: 'M50 100l8.812-8.813L23.937 56.25H100v-12.5H23.937L58.812 8.812 50 0 0 50z'
  });

});